// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewCount_root__YuI2w","count":"ViewCount_count__3Y-2H","icon":"ViewCount_icon__1CV7i"};